import React from 'react'
import PropTypes from 'prop-types'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

import './Curtains.scss'


const Curtains = ({ bg, title, text, isVisible }) => {
  const bgStyle = `url(${bg})`
  return (
    <CSSTransitionGroup
      transitionName='fi_curtains'
      transitionEnterTimeout={1000}
      transitionLeaveTimeout={800}
    >
      {isVisible &&
        <div className='fi_scene'>
          <div className='fi_curtains-doors'>
            <div id='fi_curtains__bg' className='fi_curtains__bg' style={{backgroundImage: bgStyle}} />

            <div className='fi_curtains-doors__door-wrap fi_curtains-doors__door-wrap--left'>
              <div
                className='fi_curtains-doors__door fi_curtains-doors__door--left'
                style={{backgroundImage: bgStyle}} />
            </div>
            <div className='fi_curtains-doors__door-wrap fi_curtains-doors__door-wrap--right'>
              <div
                className='fi_curtains-doors__door fi_curtains-doors__door--right'
                style={{backgroundImage: bgStyle}} />
            </div>
          </div>

          <div className='fi_curtains__text-block'>
            <h1 id='fi_curtains__title' className='fi_curtains__title'><span className='fi_curtains__title--text'>{ title }</span></h1>
            <div className='fi_curtains__divider' />
            <p id='fi_curtains__text' className='fi_curtains__text'>{ text }</p>
          </div>
        </div>
      }
    </CSSTransitionGroup>
  )
}

Curtains.propTypes = {
  bg: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  isVisible: PropTypes.bool,
}

export default Curtains



// WEBPACK FOOTER //
// ./src/templates/fashionIcon/components/Curtains.js